import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { LoginForm } from '@/components/auth/login-form';
import { LoginHero } from '@/components/auth/login-hero';
import { SignupForm } from '@/components/auth/signup-form';
import { authClient } from '@/lib/auth-client';
import { buildMeta } from '@/lib/seo';

const loginSearchSchema = z.object({
  redirect: z.string().optional(),
  mode: z.enum(['signin', 'signup']).optional(),
});

export const Route = createFileRoute('/_public/login')({
  ssr: false,
  head: () => ({
    meta: buildMeta({
      title: 'התחברות - Pricedrop',
      description: '',
      canonicalUrl: '/login',
      noindex: true,
    }),
  }),
  validateSearch: loginSearchSchema,
  beforeLoad: async ({ search }) => {
    const { data: session } = await authClient.getSession();
    if (session) {
      throw redirect({
        to: search.redirect || '/',
      });
    }
  },
  component: LoginPage,
});

function LoginPage() {
  const { redirect: redirectTo, mode } = Route.useSearch();

  return (
    <div className="mx-auto w-full max-w-5xl px-4 py-8 md:py-12">
      <div className="grid items-start gap-8 lg:grid-cols-2 lg:gap-12">
        <LoginHero />
        <div className="w-full max-w-md justify-self-center lg:justify-self-start">
          {mode === 'signup' ? (
            <SignupForm redirectTo={redirectTo} />
          ) : (
            <LoginForm redirectTo={redirectTo} />
          )}
        </div>
      </div>
    </div>
  );
}
